var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modals"},_vm._l((_vm.modals),function(modal,index){return _c(modal.name,{key:modal.name,tag:"component",class:{'modal-uppermost': index + 1 === _vm.modals.length },attrs:{"data":modal.data,"active":modal.active},on:{"closed":function($event){return _vm.remove(modal.name)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }